module.exports = __webpack_public_path__ + "static/media/meditation.f004e549.svg";